import { LockOutlined } from '@ant-design/icons';
import { Divider, Typography, Row } from 'antd';
import { isMobileOnly } from 'react-device-detect';
const logoBE = require('../../assets/onboarding/logoBE.png');
import { useTranslation, withTranslation } from 'react-i18next';

const { Text } = Typography;

function FooterComponent() {
	const { t } = useTranslation();

	return (
		<Row style={{ display: 'flex', justifyContent: 'center' }}>
			{isMobileOnly ? (
				<>
					<div style={{ width: '100%', marginTop: 24 }}>
						<div
							style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
							<LockOutlined style={{ color: '#808080', fontSize: 14 }} />
							<Text style={{ fontSize: 10, fontWeight: 400, color: '#808080', marginLeft: 8 }}>
								{t('doc.ourSecureInformation').replace(/:$/, '.')}
							</Text>
						</div>
						<Divider style={{ margin: 8 }} />
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<img src={logoBE} alt="Logo Banco de Españana" />
							<Text style={{ fontSize: 8, fontWeight: 400, color: '#808080', marginLeft: 6 }}>
								Certificada como Intermediaria
								<br />
								de Crédito Inmobiliario nº: D842
							</Text>
						</div>
					</div>
				</>
			) : (
				<>
					<Divider style={{ marginBottom: 16 }} />
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							<LockOutlined style={{ color: '#808080', fontSize: 20 }} />
							<Text style={{ fontSize: 12, fontWeight: 400, color: '#808080' }}>
								{t('doc.ourSecureInformation')}
							</Text>
						</div>
						<img src={logoBE} alt="Logo Banco de Españana" />
						<Text style={{ fontSize: 10, fontWeight: 400, color: '#808080' }}>
							Certificada como Intermediaria
							<br />
							de Crédito Inmobiliario nº: D842
						</Text>
					</div>
				</>
			)}
		</Row>
	);
}

export default withTranslation()(FooterComponent);
